import { ItemRef } from '../types/PricingCalculator';
import { pricingData } from '../data/PricingData';

export function findItemById(itemId: string): ItemRef | null {
    // Search in all-in-one devices
    for (const device of pricingData.all_in_one_devices) {
        const id = `all-in-one-${device.name.toLowerCase().replace(/\s+/g, "-")}`;
        if (id === itemId) {
            return {
                ...device,
                id,
                category: "screen" as const,
                price: { value: device.price, currency: device.currency },
                meta: {
                    builtInPrinter: device.name.toLowerCase().includes('built-in') ||
                        device.name.toLowerCase().includes('all-in-one'),
                },
            };
        }
    }

    // Search in smartphones
    for (const phone of pricingData.phone_and_printer_solution.smartphones) {
        const id = `smartphone-${phone.name.toLowerCase().replace(/\s+/g, "-")}`;
        if (id === itemId) {
            return {
                ...phone,
                id,
                category: "screen" as const,
                price: { value: phone.price, currency: phone.currency },
                meta: {
                    builtInPrinter: false,
                },
            };
        }
    }

    // Search in printers
    for (const printer of pricingData.phone_and_printer_solution.printers) {
        const id = `printer-${printer.name.toLowerCase().replace(/\s+/g, "-")}`;
        if (id === itemId) {
            return {
                ...printer,
                id,
                category: "printer" as const,
                price: { value: printer.price, currency: printer.currency },
                meta: {
                    bt: printer.name.toLowerCase().includes('bluetooth'),
                    usb: printer.name.toLowerCase().includes('usb'),
                },
            };
        }
    }

    // Search in scanners
    for (const scanner of pricingData.optional_accessories.barcode_scanners) {
        const id = `scanner-${scanner.name.toLowerCase().replace(/\s+/g, "-")}`;
        if (id === itemId) {
            return {
                ...scanner,
                id,
                category: "scanner" as const,
                price: { value: scanner.price, currency: scanner.currency },
                meta: {
                    bt: scanner.name.toLowerCase().includes('bluetooth'),
                    usb: scanner.name.toLowerCase().includes('usb'),
                },
            };
        }
    }

    // Search in adapters
    const adapters = [
        {
            id: "adapter-usb-c-to-usb-a",
            name: "USB-C to USB-A Adapter",
            description: "Adapter for connecting USB-A devices to USB-C ports",
            category: "adapter" as const,
            price: { value: 5000, currency: "RWF" as const },
            availability: "Rwanda" as const,
            link: "#",
            meta: {
                fromPort: "usb_c",
                toPort: "usb_a",
            },
        },
        {
            id: "adapter-micro-usb-to-usb-a",
            name: "Micro-USB to USB-A Adapter",
            description: "Adapter for connecting USB-A devices to Micro-USB ports",
            category: "adapter" as const,
            price: { value: 3000, currency: "RWF" as const },
            availability: "Rwanda" as const,
            link: "#",
            meta: {
                fromPort: "micro_usb",
                toPort: "usb_a",
            },
        },
        {
            id: "adapter-lightning-to-usb-a",
            name: "Lightning to USB-A Adapter",
            description: "Adapter for connecting USB-A devices to Lightning ports",
            category: "adapter" as const,
            price: { value: 8000, currency: "RWF" as const },
            availability: "Rwanda" as const,
            link: "#",
            meta: {
                fromPort: "lightning",
                toPort: "usb_a",
            },
        },
    ];

    for (const adapter of adapters) {
        if (adapter.id === itemId) {
            return adapter;
        }
    }

    return null;
}
